import type { ZendeskArticleDTO } from '../api'

class ZendeskArticle {
  readonly id: number
  readonly title: string
  readonly url: string

  constructor(dto: ZendeskArticleDTO) {
    this.id = dto.id
    this.title = dto.title
    this.url = dto.html_url
  }
}

export { ZendeskArticle }
